type UrlTypes = {
  [key: string]: {
    path: string;
    method: string;
  };
};

const urls: UrlTypes = {
  signIn: {
    path: 'auth/signin',
    method: 'POST',
  },
  createReward: {
    path: 'reward',
    method: 'POST',
  },
  updateReward: {
    path: 'reward',
    method: 'PUT',
  },
  createTier: {
    path: 'tier',
    method: 'POST',
  },
  getAllTier: {
    path: 'tier/get',
    method: 'GET',
  },
  updateTier: {
    path: 'tier',
    method: 'PUT',
  },
  customerList: {
    path: 'customers/all',
    method: 'GET',
  },
  customerOrderList: {
    path: 'customers/orders',
    method: 'GET',
  },
  getCustomerCountByTier: {
    path: 'customers/count/tier',
    method: 'GET',
  },
  getCustomerById: {
    path: 'customers',
    method: 'GET',
  },
  getAllCollectionList: {
    path: 'collection/all',
    method: 'GET',
  },
  getAllRewards: {
    path: 'reward',
    method: 'GET',
  },
  getDashboard: {
    path: 'customers/count/tier',
    method: 'GET',
  },
  getActiveRewardCount: {
    path: 'reward/active/count',
    method: 'GET',
  },
  getRewardById: {
    path: 'reward/id',
    method: 'GET',
  },
  getCustomerActivity: {
    path: 'customers/activity',
    method: 'GET',
  },
  getDashboardStats: {
    path: 'dashboard/get',
    method: 'GET',
  },
};

export default urls;
